import "../UserProfile.scss";
import { getCouresePreferences, getUserDetails } from "../Services/UserProfile.sevice";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { useEffect, useState } from "react";
import PersonalCheckSvg from "@Assets/svg/Myprofile/Profilechecked.svg"
import { EditProfileIndex } from "../EditProfile";
import ProfileBarFilled from "@Assets/svg/UserProfilesvg/ProfileBarFilled.svg";
import ProfileBarEmpty from "@Assets/svg/UserProfilesvg/ProfileBarEmpty.svg";
import TickCircle from "@Assets/svg/UserProfilesvg/TickCircle.svg";
import { Skeleton } from "primereact/skeleton";
import { GENDER } from "@Constants/app.constant";
import { uploadProfileImage } from "../Services/UserProfile.sevice";
import PhotoCropper from "@Src/components/PhotoCropper/PhotoCropper";
import { useAppSelector, useAppDispatch } from "@Src/app/hooks";
import { showSpinner } from "@Src/app/reducers/globalSlice";
import { setUserNickname, setProfileImageUrl } from "@Src/app/reducers/auth/loginSlice";
import { toast } from "react-hot-toast";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AppRouteURL } from "@Constants/app-route-url.constant";

export const MyProfileIndex = () => {
  const [profiledetails, setprofiledetails] = useState<Array<any>>([])
  const [isEdit, setIsEdit] = useState(false);
  const [coursePrefernce, setCoursePrefernce] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [proflieStrength, setProfileStrength] = useState<number>(0);
  const [prefrenceStrength, setPrefrenceStrength] = useState<number>(0);
  const [totalStrength, setTotalStrength] = useState<number>(0);
  const [barStrength, setBarStrength] = useState<number>(0);
  const [unFilledProfileDetails, setUnFilledProfileDetails] = useState<any>([]);
  const [unFilledCourseDetails, setUnFilledCourseDetails] = useState<any>([]);
  const [showCropper, setShowCropper] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string>('');
  const fileInputRef = useRef<HTMLInputElement>(null);
  const dispatch = useAppDispatch();
  const profileImageUrl = useAppSelector(state => state.login.profileImageUrl);
  const navigate = useNavigate();
  const InstituteId = useAppSelector(state => state.login.InstituteId)

  let strength: any = {
    FirstName: 5,
    LastName: 5,
    EmailId: 10,
    PhoneNo: 10,
    DOB: 10,
    Gender: 5,
    School: 10,
    stateName: 10,
    City: 10,
    boardDetails: 5,
    classDetails: 15,
    subjectDetails: 5
  }

  let detailsProfile: any = {
    FirstName: 'First Name',
    LastName: 'Last Name',
    EmailId: 'Email',
    PhoneNo: 'Mobile Number',
    DOB: 'Date of Birth',
    Gender: 'Gender',
    School: 'School Name',
    stateName: 'State',
    City: 'City',
  }

  let detailsCourses: any = {
    boardDetails: 'Board',
    classDetails: 'Class',
    subjectDetails: 'Subjects'
  }

  useEffect(() => {
    if (!isEdit) {
      getprofiledata()
    }
  }, [isEdit])

  useEffect(() => {
    getcourseprefer();
  }
    , []);

  useEffect(() => {
    setTotalStrength(proflieStrength + prefrenceStrength)
  }, [proflieStrength, prefrenceStrength])

  useEffect(() => {
    if (totalStrength > 0) {
      let barCount = totalStrength / 20;
      setBarStrength(barCount)
    }
  }, [totalStrength])


  useEffect(() => {
    if (profiledetails && profiledetails.length) {
      let calculatedStrnegth = (profiledetails[0]?.FirstName ? strength['FirstName'] : 0) + (profiledetails[0]?.LastName ? strength['LastName'] : 0) + (profiledetails[0]?.EmailId ? strength['EmailId'] : 0) + (profiledetails[0]?.PhoneNo ? strength['PhoneNo'] : 0) + (profiledetails[0]?.DOB ? strength['DOB'] : 0) + (profiledetails[0]?.Gender ? strength['Gender'] : 0) + (profiledetails[0]?.School ? strength['School'] : 0) + (profiledetails[0]?.stateName ? strength['stateName'] : 0) + (profiledetails[0]?.cityId ? strength['City'] : 0);
      setProfileStrength(calculatedStrnegth);
      let unFilledDetails: Array<string> = [];
      let keysProfile = Object.keys(detailsProfile);
      keysProfile.forEach((key: string) => {
        if (profiledetails[0][key]) {

        } else {
          unFilledDetails.push(detailsProfile[key]);
        }
      })
      setUnFilledProfileDetails(unFilledDetails);
    }
  }
    , [profiledetails]);

  const getprofiledata = () => {
    setIsLoading(true)
    getUserDetails().then((response: APIResponse) => {
      if (response.ResponseType === APIStatus.SUCCESS) {
        setprofiledetails(response?.data);
        dispatch(setUserNickname(response?.data[0]?.NickName || ''));
        setIsLoading(false);

      }
    }).catch((error: any) => {
      console.log(error)
    })
  }

  const getcourseprefer = () => {
    setIsLoading(true)
    getCouresePreferences().then((response: APIResponse) => {
      if (response.ResponseType === APIStatus.SUCCESS) {
        setCoursePrefernce(response?.data);
        setIsLoading(false);
        let calculatedStrnegth = ((response?.data?.boardDetails && response?.data?.boardDetails.length) ? strength['boardDetails'] : 0) + ((response?.data?.classDetails && response?.data?.classDetails.length) ? strength['classDetails'] : 0) + ((response?.data?.subjectDetails && response?.data?.subjectDetails.length) ? strength['subjectDetails'] : 0);
        setPrefrenceStrength(calculatedStrnegth);
        let unFilledDetails: Array<string> = [];
        let keysCourses = Object.keys(detailsCourses);
        keysCourses.forEach((key: string) => {
          if (response?.data[key] && response?.data[key].length) {

          } else {
            unFilledDetails.push(detailsCourses[key]);
          }
        })
        setUnFilledCourseDetails(unFilledDetails);

      }
    }).catch((error: any) => {
      console.log(error)
    })
  }

  function formatDate() {
    const date = new Date(profiledetails[0]?.DOB);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return profiledetails[0]?.DOB ? [day, month, year].join('-') : '';
  }

  const onClickEditDetails = () => {
    setIsEdit(true);
  }

  const handlePhotoClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    console.log("file", file);

    if (file) {
      if (file.size > 10485760) {
        toast.error('File size must be less than 10 MB');
        return;
      }
      if (!file.type.startsWith('image/')) {
        toast.error('Uploaded file should be an image');
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result as string);
        setShowCropper(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCropComplete = async (croppedImage: Blob) => {
    try {
      dispatch(showSpinner(true));
      const response = await uploadProfileImage(croppedImage);

      if (response.ResponseType === APIStatus.SUCCESS) {
        // Get updated user details to fetch the new ProfileImageUrl
        const userDetailsResponse = await getUserDetails();
        if (userDetailsResponse.ResponseType === APIStatus.SUCCESS) {
          const profileImageUrl = userDetailsResponse.data[0]?.ProfileImageUrl;
          if (profileImageUrl) {
            dispatch(setProfileImageUrl(profileImageUrl));
          }
        }
        toast.success('Profile image updated successfully');
      } else {
        toast.error(response.StatusMsg || 'Failed to upload image');
      }
      dispatch(showSpinner(false));
    } catch (error) {
      dispatch(showSpinner(false));
      toast.error('Failed to upload image');
    }
  };

  return (
    <>
      <div className="user-profile-right-container ">
        {!isLoading ? (
          <>
            <div className="tw-flex tw-justify-between">
              <div className="user-act-header  tw-flex">
                <div className="tw-mr-5 tw-relative tw-flex-shrink-0" style={{ width: '80px', height: '80px' }}>
                  <span className="user-name-card tw-block tw-w-full tw-h-full" style={{ overflow: 'hidden' }}>
                    {profileImageUrl ? (
                      <img src={profileImageUrl} alt="Profile" className="tw-w-full tw-h-full tw-object-cover tw-rounded-full" />
                    ) : (
                      <img src={require("@Assets/img/profile-picture.png")} alt="" className="tw-w-full tw-h-full tw-object-cover tw-rounded-full" />
                    )}
                  </span>
                  <div className="tw-absolute tw-bottom-0 tw-right-0 tw-bg-white tw-rounded-full tw-p-1.5 tw-shadow-lg tw-cursor-pointer tw-group" onClick={handlePhotoClick}>
                    <svg className="tw-w-3.5 tw-h-3.5 tw-text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                    </svg>
                    <div className="tw-absolute tw-bottom-full tw-left-1/2 tw-transform tw--translate-x-1/2 tw-mb-2 tw-px-2 tw-py-1 tw-bg-black tw-text-white tw-text-xs tw-rounded tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-whitespace-nowrap tw-pointer-events-none">
                      Choose Image
                    </div>
                  </div>
                </div>

                <div>
                  <div className="usr-prf-heading" style={profiledetails[0]?.NickName ? { textTransform: 'none' } : {}}>
                    {profiledetails[0]?.NickName || profiledetails[0]?.FirstName}
                  </div>
                  {coursePrefernce ? (
                    <div className="user-prf-para">
                      <span style={{ fontWeight: 600, color: '#7f56d9' }}>Course</span> : {coursePrefernce["classDetails"] && coursePrefernce["classDetails"].length ? coursePrefernce["classDetails"][0]["Name"] : ''}
                      {coursePrefernce["boardDetails"] && coursePrefernce["boardDetails"].length ? `, ${coursePrefernce["boardDetails"][0]["Name"]}` : ''}
                      {coursePrefernce["subjectDetails"] && coursePrefernce["subjectDetails"].length ? coursePrefernce["subjectDetails"]
                        .map((each: any) => `, ${each.Name}`)
                        : ''}
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="profile-strenght-bars-cards">
                    {
                      [...Array(5)].map((e, i) => (
                        <span className="profile-strenght-bars">
                          {
                            (barStrength > i) ?
                              <img src={ProfileBarFilled} alt="ProfileBarFilleday-Svg" /> :
                              <img src={ProfileBarEmpty} alt="ProfileBarEmpty-Svg" />
                          }
                        </span>
                      ))

                    }
                    {/* <span className="profile-strenght-bars">
                    <img src={ProfileBarFilled} alt="ProfileBarFilleday-Svg" />
                  </span>
                  <span className="profile-strenght-bars">
                    <img src={ProfileBarFilled} alt="ProfileBarFilleday-Svg" />
                  </span>
                  <span className="profile-strenght-bars">
                    <img src={ProfileBarFilled} alt="ProfileBarFilleday-Svg" />
                  </span>
                  <span className="profile-strenght-bars">
                    <img src={ProfileBarFilled} alt="ProfileBarFilleday-Svg" />
                  </span>
                  <span className="profile-strenght-bars">
                    <img src={ProfileBarFilled} alt="ProfileBarFilleday-Svg" />
                  </span>
                  <span className="profile-strenght-bars">
                    <img src={ProfileBarEmpty} alt="ProfileBarEmpty-Svg" />
                  </span> */}
                  </div>

                  <div className="user-prf-para">
                    Profile Strength: {totalStrength}% Profile Complete
                    {/* Profile Strength: 90% Profile Complete */}
                  </div>

                  <div className="tw-mt-4 renew-btn-mobile tw-hidden">
                    <button className="ia-btn ia-btn-primary tw-w-full" onClick={() => navigate(AppRouteURL.USERPROFILE + AppRouteURL.COURSEPREFERD)}>
                      Your Study Profile
                    </button>
                  </div>
                  {!InstituteId &&
                    <div className="tw-mt-4 renew-btn-mobile tw-hidden">
                      <button className="ia-btn ia-btn-primary tw-w-full" onClick={() => navigate(AppRouteURL.SUBSCRIPTION)}>
                        Renew Subscription
                      </button>
                    </div>
                  }


                </div>
              </div>
              <div className="tw-flex gap-3">
                <div className="renew-btn-desktop tw-block">
                  <button className="ia-btn ia-btn-primary" onClick={() => navigate(AppRouteURL.USERPROFILE + AppRouteURL.COURSEPREFERD)}>
                    Your Study Profile
                  </button>
                </div>
                <div className="renew-btn-desktop tw-block">
                  {!InstituteId &&
                    <button className="ia-btn ia-btn-primary" onClick={() => navigate(AppRouteURL.SUBSCRIPTION)}>
                      Renew Subscription
                    </button>
                  }
                </div>
              </div>


            </div>
          </>
        ) : (
          <div className="user-act-header  tw-flex">
            <span className=" tw-mr-5">
              <Skeleton
                borderRadius="50%"
                width="5rem"
                height="5rem"
              ></Skeleton>
            </span>
            <div>
              <Skeleton
                width="8rem"
                height="1.25rem"
                className="mb-2"
              ></Skeleton>
              <Skeleton width="15rem" height="1rem" className="mb-2"></Skeleton>
              <Skeleton width="10rem" height="1rem" className="mb-2"></Skeleton>
              <Skeleton width="12rem" height="1rem" className="mb-2"></Skeleton>
            </div>
          </div>
        )}

        {isEdit ? (
          <EditProfileIndex setIsEdit={setIsEdit} Userdetails={profiledetails[0]} />
        ) : (
          <div>
            {!isLoading ? (
              <div>
                {totalStrength < 100 ? (
                  <div className="user-profile-card   add-detail-card">
                    <div className="add-detail-head">
                      Complete 100% of your profile by adding your {
                        unFilledProfileDetails && unFilledProfileDetails.length ? unFilledProfileDetails.map((details: any, index: number) => `${details} ${index < unFilledProfileDetails.length - 1 ? ',' : ''}`)
                          : ''}
                      {unFilledProfileDetails && unFilledProfileDetails.length && unFilledCourseDetails && unFilledCourseDetails.length ? ',' : ''}
                      {
                        unFilledCourseDetails && unFilledCourseDetails.length ? unFilledCourseDetails.map((details: any, index: number) => `${details} ${index < unFilledCourseDetails.length - 1 ? ',' : ''}`)
                          : ''}
                    </div>
                    {proflieStrength < 75 ?
                      <button
                        className="ia-btn ia-btn-primary mt-3"
                        onClick={() => onClickEditDetails()}
                      >
                        Add Details
                      </button> : ''}
                  </div>
                ) : (
                  ""
                )}

                <div className="user-profile-card personal-detail-card tw-rounded-2xl tw-shadow-lg tw-bg-white p-0">
                  <div className="user-profile-card-main-heading tw-flex tw-items-center px-4 pt-4">
                    Personal Details
                    <span className="tw-ml-8">
                      <img src={TickCircle} alt="TickCircle-Svg" />
                    </span>
                  </div>

                  <div className="user-p-c-para-1 px-4">
                    {profiledetails[0]?.FirstName} {profiledetails[0]?.LastName}
                  </div>
                  <div className="px-4 pb-4">

                    <div className="tw-mt-3">
                      <div className="tw-text-lg font-semibold">Nick Name</div>
                      {
                        profiledetails[0]?.NickName ? <div>{profiledetails[0]?.NickName}</div> : <div>{'...........'}</div>
                      }

                    </div>

                    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 gap-3 tw-mt-5">
                      <div>
                        <div className="tw-text-lg font-semibold">Email</div>
                        <div className="tw-break-all">
                          {profiledetails[0]?.EmailId ? profiledetails[0]?.EmailId : '...........'}
                        </div>
                      </div>
                      <div>
                        <div className="tw-text-lg font-semibold">
                          Mobile Number
                        </div>
                        <div>
                          {
                            profiledetails[0]?.PhoneNo && profiledetails[0]?.CountryCode ? ` +${profiledetails[0]?.CountryCode}XXXXXX${profiledetails[0].PhoneNo.slice(-4)}` : '...........'
                          }

                        </div>
                      </div>
                    </div>

                    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 gap-3 tw-mt-5">
                      <div>
                        <div className="tw-text-lg font-semibold">Parent Email Id</div>
                        <div className="tw-break-all">
                          {profiledetails[0]?.ParentEmailId ? profiledetails[0]?.ParentEmailId : '...........'}
                        </div>
                      </div>

                      <div>
                        <div className="tw-text-lg font-semibold">Parent Mobile Number</div>
                        {
                          profiledetails[0]?.ParentPhone ? <div>
                            +{profiledetails[0]?.ParentCountryCode}XXXXXX{profiledetails[0].ParentPhone.slice(-4)}
                          </div> : <div>{'...........'}</div>
                        }

                      </div>

                    </div>

                    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 gap-3 tw-mt-5">
                      <div className="">
                        <div className="tw-text-lg font-semibold">
                          Date of Birth
                        </div>
                        <div>{profiledetails[0]?.DOB ? formatDate() : '...........'}</div>
                      </div>
                      <div>
                        <div className="tw-text-lg font-semibold">
                          Gender
                        </div>
                        <div>
                          {profiledetails[0]?.Gender ?
                            GENDER[profiledetails[0]?.Gender]
                            : '...........'}
                        </div>
                      </div>
                    </div>
                    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 gap-3 tw-mt-5">
                      <div>
                        <div className="tw-text-lg font-semibold">
                          School Name
                        </div>
                        <div>
                          {profiledetails[0]?.School ? profiledetails[0]?.School : '...........'}
                        </div>
                      </div>
                      <div>
                        <div className="tw-text-lg font-semibold">
                          Street Address
                        </div>
                        <div>
                          {profiledetails[0]?.Address ? profiledetails[0]?.Address : '...........'}
                        </div>
                      </div>

                    </div>
                    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 gap-3 tw-mt-5">
                      <div>
                        <div className="tw-text-lg font-semibold">
                          City
                        </div>
                        <div>
                          {profiledetails[0]?.cityName ? profiledetails[0]?.cityName : '...........'}
                        </div>
                      </div>
                      <div>
                        <div className="tw-text-lg font-semibold">
                          State
                        </div>
                        <div>
                          {profiledetails[0]?.stateName ? profiledetails[0]?.stateName : '...........'}
                        </div>
                      </div>

                      <div>

                      </div>
                    </div>
                  </div>
                  <div className="tw-text-center tw-mt-9 tw-pb-8">
                    <button
                      className="ia-btn ia-btn-primary px-4"
                      onClick={() => onClickEditDetails()}
                    >
                      Edit Details
                    </button>
                  </div>
                </div>


              </div>
            ) : (
              <div className="user-profile-card personal-detail-card">
                <div>
                  <Skeleton
                    width="15rem"
                    height="1.25rem"
                    className="tw-my-3"
                  ></Skeleton>
                  <Skeleton
                    width="15rem"
                    height="1.25rem"
                    className="tw-my-3"
                  ></Skeleton>
                </div>
                <div className="tw-flex tw-flex-wrap tw-justify-between tw-mt-5">
                  <div>
                    <Skeleton
                      width="15rem"
                      height="1.25rem"
                      className="tw-my-3"
                    ></Skeleton>
                    <Skeleton
                      width="15rem"
                      height="1.25rem"
                      className="tw-my-3"
                    ></Skeleton>
                  </div>
                  <div>
                    <Skeleton
                      width="15rem"
                      height="1.25rem"
                      className="tw-my-3"
                    ></Skeleton>
                    <Skeleton
                      width="15rem"
                      height="1.25rem"
                      className="tw-my-3"
                    ></Skeleton>
                  </div>

                  <div className="tw-mt-5">
                    <Skeleton
                      width="15rem"
                      height="1.25rem"
                      className="tw-my-3"
                    ></Skeleton>
                    <Skeleton
                      width="15rem"
                      height="1.25rem"
                      className="tw-my-3"
                    ></Skeleton>
                  </div>
                </div>

                <div className="tw-text-center tw-mt-9 tw-mb-2">
                  <Skeleton
                    width="10rem"
                    height="3rem"
                    className="tw-mx-auto"
                  ></Skeleton>
                </div>
              </div>
            )}
          </div>
        )}
      </div >

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
        className="tw-hidden"
      />

      <PhotoCropper
        visible={showCropper}
        onHide={() => setShowCropper(false)}
        imageSrc={selectedImage}
        onCropComplete={handleCropComplete}
      />
    </>
  );
};